import { certURL } from "../Config/Url";
import axios from "axios";

export const certificateService = {
  uploadCert,
  getById,
  updateCert,
  deleteCert,
  uploadMiniCert,
  download,
  decryptPassword
};

async function uploadCert(formData) {
  return axios
    .post(certURL, formData)
    .then((res) => res)
    .catch((err) => err.response);
}

async function uploadMiniCert(formData) {
  return axios
    .post(certURL + "/mini", formData)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getById(id) {
  return axios
    .get(`${certURL}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function updateCert(
  certificateId,
  validFrom,
  validTo,
  certPassword,
  name
) {
  console.log("cc", certPassword);
  return axios
    .put(`${certURL}/${certificateId}`, {
      validFrom,
      validTo,
      certPassword,
      name,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteCert(id) {
  return axios
    .delete(`${certURL}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}
async function download(id) {
  return axios
    .get(`${certURL}/${id}/download`,{
    responseType: 'blob'
})
    .then((res) => res)
    .catch((err) => err.response);
}

async function decryptPassword(id) {
  return axios
    .get(`${certURL}/decrypt-password`, { params: { id } })
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}

